import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Switch, Route } from 'react-router-dom';
import Bundle from '@saucelabs/sl-component-bundle';
import { InExperimentContainer, RedirectToDjango } from '@saucelabs/sl-container-experiment';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';

const importTestHistory = () => import(/* webpackChunkName: "an-test-history" */ './containers/TestHistoryContainer');
const importTestOverview = () => import(/* webpackChunkName: "an-test-overview" */ './containers/TestOverviewContainer');
const importTrends = () => import(/* webpackChunkName: "an-trends" */ './containers/TrendsContainer');
const importFailureAnalysis = () => import(/* webpackChunkName: "an-failure-analysis" */ './containers/FailureAnalysisContainer');

const InExperiment = withRouter(InExperimentContainer);

const AnalyticsRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <Switch>
      <Route
        path={`${match.url}/test-history`}
        render={(props) => (
          <Bundle load={importTestHistory}>
            {(Component) => (
              <Component
                activeTab={match.url}
                {...props}
              />
            )}
          </Bundle>
        )}
      />
      <Route
        path={`${match.url}/failure/root-causes`}
        render={(props) => (
          <InExperiment name="web-ui-failure-analysis">
            <Bundle load={importFailureAnalysis}>
              {(Component) => (
                <Component
                  activeTab={match.url}
                  {...props}
                />
              )}
            </Bundle>
          </InExperiment>
        )}
      />
      <Route
        path={`${match.url}/failure`}
        render={(props) => (
          <InExperiment name="web-ui-failure-analysis">
            <Bundle load={importFailureAnalysis}>
              {(Component) => (
                <Component
                  activeTab={match.url}
                  {...props}
                />
              )}
            </Bundle>
          </InExperiment>
        )}
      />
      <Route
        path={`${match.url}/test-overview/errors`}
        render={(props) => (
          <InExperiment name="web-ui-test-overview">
            <Bundle load={importTestOverview}>
              {(Component) => (
                <Component
                  activeTab={match.url}
                  {...props}
                />
              )}
            </Bundle>
          </InExperiment>
        )}
      />
      <Route
        path={`${match.url}/test-overview/tests`}
        render={(props) => (
          <InExperiment name="web-ui-test-overview">
            <Bundle load={importTestOverview}>
              {(Component) => (
                <Component
                  activeTab={match.url}
                  {...props}
                />
              )}
            </Bundle>
          </InExperiment>
        )}
      />
      <Route
        path={`${match.url}/test-overview`}
        render={(props) => (
          <InExperiment name="web-ui-test-overview">
            <Bundle load={importTestOverview}>
              {(Component) => (
                <Component
                  activeTab={match.url}
                  {...props}
                />
              )}
            </Bundle>
          </InExperiment>
        )}
      />
      <Route
        path={`${match.url}/trends`}
        render={(props) => (
          <Bundle load={importTrends}>
            {(Component) => (
              <Component
                activeTab={match.url}
                {...props}
              />
            )}
          </Bundle>
        )}
      />
      {/* Redirect if there no Route match to switch to Django app */}
      <Route component={RedirectToDjango} />
    </Switch>
  </LoginRequiredContainer>
);

AnalyticsRoutes.propTypes = {
  location: PropTypes.any.isRequired,
  match: PropTypes.object.isRequired,
};

export default AnalyticsRoutes;
